export enum UploadFileType {
  KML = 'kml',
  KMZ = 'kmz',
  SHP = 'shp',
  ZIP = 'zip',
}
